(() => {
  if (window.civicoNotimProductCustomization) return;
  window.civicoNotimProductCustomization = true;

  const sourceLabel = 'EMAIL WHEN AVAILABLE';
  const translatedLabel = 'Avvisami quando torna disponibile';
  const popupTranslations = new Map([
    ['EMAIL WHEN AVAILABLE', translatedLabel],
    ['NOTIFY WHEN AVAILABLE', 'Avvisami quando torna disponibile'],
    ['GET AN EMAIL WHEN THIS PRODUCT IS BACK IN STOCK.', "Ricevi un'email quando questo prodotto torna disponibile."],
    ['EMAIL ADDRESS', 'Indirizzo email'],
    ['EMAIL ME WHEN AVAILABLE', translatedLabel],
    [
      'WE RESPECT YOUR PRIVACY AND WILL NEVER SHARE YOUR EMAIL WITH ANYONE.',
      'Rispettiamo la tua privacy e non condivideremo mai la tua email con nessuno.',
    ],
  ]);
  const mobileMedia = window.matchMedia('(max-width: 749px)');
  let animationFrame;

  const normalizeText = (value) => value.replace(/\s+/g, ' ').trim().toUpperCase();

  const translateValue = (value) => {
    const translatedValue = popupTranslations.get(normalizeText(value));
    return translatedValue || value;
  };

  const translateNotimCopy = (root = document.body) => {
    if (!root) return;

    const candidateSelector = [
      '.na-back-in-stock-container',
      '.nm-btn',
      '.nm-btn-container',
      '[class*="notim" i]',
      '[id*="notim" i]',
      '[class*="nm-" i]',
      '[id*="nm-" i]',
    ].join(',');

    const candidates = root.matches?.(candidateSelector)
      ? [root]
      : Array.from(root.querySelectorAll?.(candidateSelector) || []);

    candidates.forEach((candidate) => {
      const textWalker = document.createTreeWalker(candidate, NodeFilter.SHOW_TEXT);
      let textNode = textWalker.nextNode();

      while (textNode) {
        const currentText = textNode.nodeValue;
        const translatedText = translateValue(currentText);

        if (translatedText !== currentText) {
          textNode.nodeValue = translatedText;
        }

        textNode = textWalker.nextNode();
      }

      candidate.querySelectorAll('input, textarea, button').forEach((field) => {
        ['placeholder', 'aria-label', 'value'].forEach((attribute) => {
          const currentValue = field.getAttribute(attribute);
          if (!currentValue) return;

          const translatedValue = translateValue(currentValue);
          if (translatedValue !== currentValue) {
            field.setAttribute(attribute, translatedValue);
          }
        });
      });
    });
  };

  const customizeNotim = () => {
    document.querySelectorAll('product-info[id^="MainProduct-"]').forEach((productInfo) => {
      const infoContainer = productInfo.querySelector('.product__info-container');
      const notimContainer = infoContainer?.querySelector('.na-back-in-stock-container');
      const notimBlock = notimContainer?.closest('.shopify-app-block');
      const priceBlock = infoContainer?.querySelector('[id^="price-"]');

      if (!infoContainer || !notimContainer || !notimBlock || !priceBlock) return;

      notimBlock.classList.add('civico-notim-product-block');

      notimContainer.querySelectorAll('.nm-btn').forEach((button) => {
        if (button.textContent.trim().toUpperCase() === sourceLabel) {
          button.textContent = translatedLabel;
        }
      });

      translateNotimCopy(notimContainer);

      let anchor = infoContainer.querySelector('[data-civico-notim-anchor]');
      if (!anchor) {
        anchor = document.createElement('span');
        anchor.hidden = true;
        anchor.setAttribute('data-civico-notim-anchor', '');
        notimBlock.before(anchor);
      }

      if (mobileMedia.matches) {
        if (priceBlock.nextElementSibling !== notimBlock) {
          priceBlock.after(notimBlock);
        }
      } else if (anchor.nextElementSibling !== notimBlock) {
        anchor.after(notimBlock);
      }
    });
  };

  const scheduleCustomization = () => {
    window.cancelAnimationFrame(animationFrame);
    animationFrame = window.requestAnimationFrame(() => {
      customizeNotim();
      translateNotimCopy();
    });
  };

  const initialize = () => {
    customizeNotim();
    translateNotimCopy();

    document.querySelectorAll('product-info[id^="MainProduct-"]').forEach((productInfo) => {
      const observer = new MutationObserver(scheduleCustomization);
      observer.observe(productInfo, { childList: true, subtree: true });
    });

    const bodyObserver = new MutationObserver(scheduleCustomization);
    bodyObserver.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('nmCustomEventLoad', scheduleCustomization);
    document.addEventListener('shopify:section:load', scheduleCustomization);

    if (mobileMedia.addEventListener) {
      mobileMedia.addEventListener('change', scheduleCustomization);
    } else {
      mobileMedia.addListener(scheduleCustomization);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
